export const groupHeight = 44;
export const itemHeightRatio = 0.92;
